module.exports = __webpack_public_path__ + "img/icon8.60fed457.png";